export const BLOCK_SELECTOR = '.js-webpack-block'
export const PACKED_BLOCK_CLASS = 'js-pack-block'
export const PENDING_CLASS = 'js-pending'
export const LOADING_CLASS = 'js-loading'
export const LAZY_BLOCK_SELECTOR = '.js-webpack-lazy-block'
export const PRIORITIZED_BLOCK_CLASS = 'js-prioritized-block'
